import { Box, Text } from '@chakra-ui/react'
import { FaStickyNote } from 'react-icons/fa'
import { colors } from '../../../utilities/colors'

export default function LocationInstructions({ label, notes }) {
  if (!notes) return null

  return (
    <Box
      p={2.5}
      borderRadius="md"
      bg={colors.grey900}
      border="1px solid"
      borderColor={colors.grey700}
      display="flex"
      flexDirection="column"
      gap={1}
    >
      <Box display="flex" alignItems="center" gap={1.5}>
        <FaStickyNote size={10} color={colors.grey300} />
        <Text fontSize="xs" color={colors.grey300} fontWeight="semibold">{label}</Text>
      </Box>
      <Text fontSize="xs" color={colors.grey100} whiteSpace="pre-wrap">{notes}</Text>
    </Box>
  )
}
